// import React from 'react';
// import { Routes, Route } from 'react-router-dom';
// import "./App.css"

// import Navbar from './components/Navbar';
// import Footer from './components/Footer';
// import HomePage from './pages/HomePage';
// import ServicesPage from './pages/ServicesPage';
// import AboutUsPage from './pages/AboutUsPage';
// import ContactUsPage from './pages/ContactUsPage';
// import ProductsPage from './pages/ProductPage';
// import Topbar from './components/Topbar';
// import { ChatWidget } from './components/ChatWidge';
// import PrivacyPolicyLink from './components/PrivacyPolicyLink ';
// import ScrollToTop from './components/ScrollToTop';

// const App = () => {
//   const style = document.createElement('style');
// style.innerHTML = `
//   html {
//     scroll-behavior: smooth;
//   }
// `;
// document.head.appendChild(style);

//   return (
//     <>
//     <ScrollToTop/>
//     <Navbar />
//     <Topbar/>
//       <Routes>
//         <Route path="/" element={<HomePage />} />
//         <Route path="/services" element={<ServicesPage />} />
//         <Route path="/products" element={<ProductsPage />} />
//         <Route path="/about" element={<AboutUsPage />} />
//         <Route path="/contact" element={<ContactUsPage />} />
//         <Route path="/privacy" element={<PrivacyPolicyLink />} />
//       </Routes>
//       <ChatWidget/>
//       <Footer />
//     </>
//   );
// };

// export default App;

import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import "./App.css";

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import AboutUsPage from './pages/AboutUsPage';
import ContactUsPage from './pages/ContactUsPage';
import ProductsPage from './pages/ProductPage';
import Topbar from './components/Topbar';
import { ChatWidget } from './components/ChatWidge';
import PrivacyPolicyLink from './components/PrivacyPolicyLink ';
import ScrollToTop from './components/ScrollToTop';

const App = () => {

  // ✅ Inject global smooth scroll behavior once
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      html {
        scroll-behavior: smooth;
      }
    `;
    document.head.appendChild(style);

    return () => {
      // Optional: clean up on unmount
      document.head.removeChild(style);
    };
  }, []);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Topbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/privacy" element={<PrivacyPolicyLink />} />
      </Routes>
      <ChatWidget />
      <Footer />
    </>
  );
};

export default App;

